import { useCallback } from "react";
import { useState } from "react";
import ConfirmDialogContext from "./ConfirmDialogContext";
import ConfirmDialog from "../components/ui/ConfirmDialog";

const ConfirmDialogContextProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: null,
    onClose: null,
    confirmText: "Yes",
    cancelText: "Cancel",
  });

  const confirm = useCallback(({ title, content, confirmText, cancelText }) => {
    return new Promise((resolve) => {
      setConfirmState({
        open: true,
        title,
        content,
        confirmText: confirmText || "Yes",
        cancelText: cancelText || "Cancel",
        onConfirm: () => {
          resolve(true);
          setConfirmState((s) => ({ ...s, open: false }));
        },
        onClose: () => {
          resolve(false);
          setConfirmState((s) => ({ ...s, open: false }));
        },
      });
    });
  }, []);

  return (
    <ConfirmDialogContext.Provider value={{ confirm }}>
      {children}
      <ConfirmDialog
        open={confirmState.open}
        title={confirmState.title}
        content={confirmState.content}
        confirmText={confirmState.confirmText}
        cancelText={confirmState.cancelText}
        onConfirm={confirmState.onConfirm}
        onClose={confirmState.onClose}
      />
    </ConfirmDialogContext.Provider>
  );
};
export default ConfirmDialogContextProvider;
